import * as React from 'react';
import { Progress } from 'reactstrap';

import './progressBar.css';

const ProgressBar = props => {
    return (
        <div id = "progress-bar" >
            <Progress
                value = {props.fraction/props.total * 100}
                barClassName = "prog-bar"
            />
            <div style={props.showLabel ? {display: "block"} : {display: "none"}} className="text-left">{`${props.fraction} / ${props.total}`} Completed</div>
            {/* <div style={props.showLabel ? {display: "block"} : {display: "none"}} className="text-left">{Math.round(props.fraction/props.total * 100 * 100)/100} % Completed</div> */}
        </div>
    );
};

export default ProgressBar;


// WEBPACK FOOTER //
// ./src/common/progressBar.Component.tsx